import { render, staticRenderFns } from "./ForcaDeVendas.vue?vue&type=template&id=756510c4"
import script from "./ForcaDeVendas.vue?vue&type=script&lang=js"
export * from "./ForcaDeVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports